<template>
  <div v-if="showTab === 2">
    <md-card-content>
      <table class="flex-table td-text-align-right">
        <tr>
          <th>일반회비</th>
          <td>{{ privateTotalSum[0] != null ? formatter.getCurrency(privateTotalSum[0].feeCnt) : 0 }} 건</td>
          <td>{{ privateTotalSum[0] != null ? formatter.getCurrency(privateTotalSum[0].feeAmt) : 0 }} 원</td>
        </tr>
        <tr>
          <th>평생회비</th>
          <td>{{ privateTotalSum[1] != null ? formatter.getCurrency(privateTotalSum[1].feeCnt) : 0 }} 건</td>
          <td>{{ privateTotalSum[1] != null ? formatter.getCurrency(privateTotalSum[1].feeAmt) : 0 }} 원</td>
        </tr>
        <tr>
          <th>합계</th>
          <td>{{ formatter.getCurrency((privateTotalSum[0] != null ? privateTotalSum[0].feeCnt : 0) + (privateTotalSum[1] != null ? privateTotalSum[1].feeCnt : 0)) }} 건</td>
          <td>{{ formatter.getCurrency((privateTotalSum[0] != null ? privateTotalSum[0].feeAmt : 0) + (privateTotalSum[1] != null ? privateTotalSum[1].feeAmt : 0)) }} 원</td>
        </tr>
      </table>
      <h4>납부 구분별</h4>
      <md-table :value="privateTotalData" class="paginated-table table-striped table-hover text-align-center h400">
        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell md-label="납부구분" style="color:#0091d5; cursor:pointer" @click.native="privateQueryByType(item)">{{ item.feeWayNm }}</md-table-cell>
          <md-table-cell md-label="회비구분">{{ item.feeCdNm }}</md-table-cell>
          <md-table-cell md-label="납입건수" style="text-align: right;">{{ formatter.getCurrency(item.feeCnt) }} 건</md-table-cell>
          <md-table-cell md-label="납입금액" style="text-align: right;">{{ formatter.getCurrency(item.feeAmt) }} 원</md-table-cell>
        </md-table-row>
      </md-table>
    </md-card-content>
    <md-card-content>
      <div class="table-header-info">
        <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
        <div>
          <select v-model="pagination.perPage" name="pages" @change="perPageChange">
            <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
              {{ item }}
            </option>
          </select>
        </div>
      </div>

      <grid ref="paymentListGrid"
            :data="gridProps.data"
            :columns="gridProps.columns"
            :options="gridProps.options"
            :theme="gridProps.theme"
            :rowHeaders="gridProps.rowHeaders"
            :columnOptions="gridProps.columnOptions"
            :language="gridProps.lang"
            @response="response"
      ></grid>


    </md-card-content>
    <md-card-actions md-alignment="space-between">

      <div class="md-alignment-space-between-right">
        <md-button class="md-success md-sm" :disabled="this.pagination.total === 0" @click="downloadExcel(item)" v-exel-btn="[5,3]">
          <md-icon>get_app</md-icon>
          Excel 다운로드
        </md-button>
      </div>
    </md-card-actions>
  </div>
</template>
<script>

import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import formatter from "@/kuaa/kuaa-formatter";
import { Grid } from '@toast-ui/vue-grid';
import moment from "moment";
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';

import Swal from "sweetalert2";
import kuaaFnc from "@/kuaa/kuaa-comm-func";

export default {
  name: "PaymentListPrivateComp",
  props: {
    showTab : {
      type : Number,
      default : 1
    },
    queryData : {
      type : Object
    }
  },
  components: {
    grid: Grid
  },

  created() {
     this.initGrid();
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },
  data() {
    return {
      formatter,
      privateTotalSum: [
        {"feeCdNm":'',"feeCd":'',"feeAmt":0,"feeCnt":0},
        {"feeCdNm":'',"feeCd":'',"feeAmt":0,"feeCnt":0}
      ],
      privateTotalData: [],
      privateListData: [],
      pagination: {
        perPage: 20,
        page: 1,
        perPageOptions: [20, 50, 100, 200, 500],
        total: 0
      },
      option: {}
    };
  },
  methods: {
    sendQuery (query) {
      this.option = query ? query : {};
      this.option['feeGb'] = '01';
      if(this.option.feeCd.indexOf("12") > 0){
      	this.option.feeCd.splice(this.option.feeCd.indexOf("12"),1);
      }
      kuaaApi.sendServer(
        URL_CONST.GET_FEE_LIST_TOTAL,
        this.option,
        "post",
        (response) => {
          this.privateTotalSum = response.data.data.contents.feeTotalInfo1;
          this.privateTotalData = response.data.data.contents.feeTotalInfo2;
          this.option.startDate = this.option.startDate != '' ? moment(this.option.startDate).format("YYYYMMDD") : this.option.startDate;
          this.option.endDate = this.option.endDate != '' ? moment(this.option.endDate).format("YYYYMMDD") : this.option.endDate;
          this.option.feeGb = '01';
          this.$refs.paymentListGrid.invoke("readData", 1, this.option);
        }
      );
    },
    privateQueryByType(item) {
      let params = {
        "feeWay" : item.feeWay,
        "feeCd" : item.feeCd,
        "feeGb" : item.feeGb,
        "startDate" : this.option.startDate,
        "endDate" : this.option.endDate
      }
      this.option.feeWay = item.feeWay;
      this.option.feeCd  = item.feeCd;      
      this.$refs.paymentListGrid.invoke("readData", 1, params);
    },
    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.paymentListGrid, event, this.pagination);
    },
    initGrid() {
        this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_FEE_LIST, false, this.pagination);
        this.gridProps['el'] = this.$refs.paymentListGrid;
        this.gridProps['columns'] = [
          {header: '교우번호', name: 'memberNo', align:"center", sortable: true},
          {header: '교우명', name: 'memberHnm', sortable: true},
          {header: '교우직위', name: 'orgNm', align:"center", sortable: true},
          {header: '대학명', name: 'collegeNm', align:"center", sortable: true},
          {header: '학과명', name: 'classNm', sortable: true},
          {header: '학번', name: 'hakbun', align:"center", sortable: true},
          {header: '졸업회수', name: 'graduationNo', align:"center", sortable: true},
          {header: '입학년도', name: 'enterYm', align:"center", sortable: true,
            formatter(value) {
              return (value.value && value.value.length == 6) ? formatter.getDateFormat(value.value) : value.value;
            }
          },
          {header: '졸업년도', name: 'graduationYm', align:"center", sortable: true,
            formatter(value) {
              return (value.value && value.value.length == 6) ? formatter.getDateFormat(value.value) : value.value;
            }
          },
          {header: '회비구분', name: 'feeCdNm', align:"center", sortable: true},
          {header: '납부일자', name: 'lastFeeDate', align:"center", sortable: true},
          {header: '납부년도', name: 'lastFeeYear', align:"center", sortable: true},
          {header: '납부방법', name: 'feeWayNm', align:"center", sortable: true},
          {header: '납부금액', name: 'feeAmt', align:"right", sortable: true,
            formatter(value) {return value.value ? formatter.getCurrency(value.value) : null;}
          },
          {header: '휴대폰', name: 'cellular', align:"center", sortable: true},
          {header: '이메일', name: 'eMail', sortable: true}
        ];
    },
    response(e) {
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
      }else{
        kuaaFnc.gridErrorCallback(e,"개인 납부리스트");
      }
    },
    downloadExcel(item) {
       if(this.pagination.total > 100000){
        kuaaFnc.showSwal("엑셀 다운로드", "다운로드 대상은 100,000건 이하여야 합니다.");
        return false;
      }    
      this.option.page = 1;
      this.option.perPage = this.pagination.total;
      this.option.fileName = '납부상세내역(개인_납부리스트)';      
      kuaaApi.requestFileDownload(
          URL_CONST.FEE_LIST_EXCEL_DOWNLOAD,
          this.option,
          '납부상세내역(개인_납부리스트).xlsx',
          response => {
            this.option.page = this.pagination.page;
            this.option.perPage = this.pagination.perPage;
          }
      );
    }
  }
};
</script>

<style lang="css" scoped>

</style>